<template>
	<div class="nakladnoyWholesale">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{
						$t('back')
					}}
				</b-button>
			</div>
			<b-spinner style="margin-left: 40%" v-if="loaders" variant="primary" label="Spinning"></b-spinner>
			<div class="pull-right">
				<b-button
					v-if="showSaccessAkt"
					variant="outline-primary"
					class="mr-2"
					@click="sendRecount"
				>
					{{ $t('actions.recount') }} <i class="fas fa-count"></i>
				</b-button>
				<b-button
					v-if="showSaccessAkt"
					variant="outline-warning"
					class="mr-2"
					@click="Act"
				>
					Аст на экпертизу <i class="fas fa-file-contract"></i>
				</b-button>
				<b-button
					v-if="showSaccess"
					variant="outline-success"
					class="mr-2"
					@click="saveCheckingNakladnoy"
				>
					{{ $t('save-finish') }}
				</b-button>
				<a class="mr-2" :href="`${publicPath}excel/Приход checking.xlsx`" download>{{ $t('excel-export.download-template') }}</a>
				<b-button
					variant="success"
					class="mr-2"
					@click="addButton"
				>
					<i class="fas fa-file-upload"></i>
				</b-button>

				<b-button v-if="showReset"
						  @click="clearFiles"
						  variant="primary"
						  class="mr-2">{{ $t('incomes.search.clear') }}
				</b-button>
<!--				<xlsx-workbook class="pull-right">-->
<!--					<xlsx-sheet-->
<!--						:collection="dataForExcel"-->
<!--						v-for="sheet in dataForExcel"-->
<!--						:key="sheet.excelName"-->
<!--						:sheet-name="sheet.excelName"-->
<!--					/>-->

<!--					<xlsx-download>-->
<!--						<b-button v-if="showReset" class="mr-2"-->
<!--								  @click="exportToExcel"-->
<!--								  variant="outline-success">Cкачать таблицу <i-->
<!--							class="fas fa-file-excel"></i>-->
<!--						</b-button>-->
<!--					</xlsx-download>-->
<!--				</xlsx-workbook>-->
				<!--				<b-button-->
				<!--					variant="outline-dark"-->
				<!--					class="mr-2"-->

				<!--				>-->
				<!--					<i class="fa fa-print"></i>-->
				<!--					{{ $t('pricing.print') }} {{ $t('goods.barcode') }}-->
				<!--				</b-button>-->
<!--				<b-button-->
<!--					variant="outline-dark"-->
<!--					@click="print"-->
<!--					class="mr-2"-->
<!--				>-->
<!--					<i class="fa fa-print"></i>-->
<!--					{{ $t('Печать') }}-->
<!--				</b-button>-->
			</div>
		</div>
		<br>
		<br>
		<div class="doc-body">
			<b-card class="p-1">
				<br>
				<div class="mb-3" id="nakladnoyTableWrapper">
					<table class="table table-striped" id="tableForExcel">
						<tr>
							<th class="text-center">№</th>
							<th class="text-center">{{ $t('goods.name') }}</th>
							<th class="text-center">{{ $t('goods.special-barcode') }}</th>
							<th class="text-center">{{ $t('goods.barcode') }}</th>
							<th class="text-center">{{ $t('kirim.expirationDate') }}</th>
							<th class="text-center">Кол-во на приход</th>
							<th class="text-center">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center">Разница</th>
							<!--							<th class="text-center">{{ $t('goods.sale-cent') }}</th>-->
							<!--							<th class="text-center">{{ $t('goods.inv-cent') }}</th>-->
							<!--							<th class="text-center">{{ $t('goods.invSumma') }}</th>-->
							<!--							<th class="text-center">{{ $t('goods.kirimCent') }}</th>-->
							<!--							<th class="text-center">{{ $t('goods.saleCent') }}</th>-->
						</tr>
						<template>
							<tr v-for="(i,index) in item.whItems" :key="i.id"
								:style="i.equal=='-'? 'background-color: #f67373':i.equal=='+'? 'background-color: #5AAFE8FF' :i.newCount==0? 'background-color: #8aee79': 'background-color: white'"
							>
								<td width="1%" class="text-center">{{ index + 1 }}</td>
								<!--																<pre>{{ i }}</pre>-->
								<td width="10%">
									<p class="text-center">
										{{ i.itemName }}
									</p>
								</td>
								<td width="6%" class="text-center">
									{{ i.barcode }}
								</td>
								<td width="5%" class="text-center">
									<p v-for="barcode in i.multiBarcodes">{{ barcode.barcode }}</p>
								</td>
								<td width="5%" class="text-center">
									<p>{{ i.termOfItem }}</p>
								</td>
								<td width="5%">
									<p class="text-center">
										{{ i.count }}
									</p>
								</td>
								<td width="5%">
									<p class="text-center">
										{{ i.newCountExcel }}
									</p>
								</td>
								<td width="5%">
									<p class="text-center" v-if="i.newCount>0 || i.newCount==0 ">
										{{ `${i.equal} ${i.newCount}` }}
									</p>
								</td>
								<!--								<td width="3%">-->
								<!--									<p>-->
								<!--									</p>-->
								<!--								</td>-->
								<!--								<td  width="3%"-->
								<!--								>-->
								<!--									<p class="text-center mt-3 small">-->

								<!--										<b-badge :variant="i.equal == '-' ? 'danger' : 'success'" v-if="i.newCount>0">-->

								<!--										</b-badge>-->
								<!--									</p>-->
								<!--								</td>-->
								<!--								<td width="5%">-->
								<!--									<p>-->
								<!--									</p>-->
								<!--								</td>-->
								<!--								<td width="5%">-->
								<!--									<p class="ml-2 pt-3">-->
								<!--									</p>-->
								<!--								</td>-->
								<!--								<td width="5%">-->
								<!--									<p class="ml-2 pt-3">-->
								<!--									</p>-->
								<!--								</td>-->
							</tr>
						</template>
					</table>
				</div>
			</b-card>
			<b-form-file
				accept=".xlsx, xls"
				v-model="file"
				ref="fileinput"
				style="display: none"
				@change="processFile($event)"
				id="fileUpload"
			></b-form-file>
		</div>
	</div>
</template>

<script>
import WhDocument from "../../../../services/wh-document.service";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import XLSX from "xlsx";

export default {

	name: 'checkNaklodnoy',
	components: {
		XlsxWorkbook,
		XlsxSheet,
		XlsxDownload
	},
	data() {
		return {
			item: {},
			file: null,
			showReset: false,
			showSaccess: false,
			publicPath: process.env.BASE_URL,
			loaders: false,
			showSaccessAkt: false,
			depId: null,
			totalItemSum: 0,
			dataForExcel: [],
			excelName: 'test',
			search: {
				limit: 10,
				page: 1
			}
		}
	},
	computed: {},
	methods: {
		saveCheckingNakladnoy() {
			WhDocument.saveAndFinishIncomeDoc(this.$route.params.id).then(res => {
				this.$router.go(-2)
				this.$vs.notify({
					text: 'Документ успешно сохранен',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		goBackToFrom() {
			this.$router.back();
		},
		print() {
			window.print();
		},
		addButton() {
			document.querySelector("#fileUpload").click()
		},
		clearFiles() {
			this.item.whItems = null
			this.get()
			this.showReset = false
			this.showSaccess = false
			this.showSaccessAkt = false
		},
		async sendRecount() {
			let obj = []
			this.item.whItems.forEach(t => {
				if (t.equal != "") {
					if (t.newCountExcel) {
						t.temporaryQty = t.newCountExcel
					} else {
						t.temporaryQty = t.count
					}
				}
				if (!t.itemId) {
					t.multiBarcode = t.multiBarcodes[0].barcode
					t.temporaryQty = t.newCountExcel
				}
				if (t.newCount != 0) {
					obj.push(t)
				}
			})
			await WhDocument.Recount(this.item.id, obj).then(response => {
				this.$router.go(-2)
				this.$vs.notify({
					text: "Success",
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async Act() {
			let obj = []
			this.item.whItems.forEach(t => {
				if (t.newCountExcel) {
					t.temporaryQty = t.newCountExcel
				} else {
					t.temporaryQty = t.count
				}
				if (!t.itemId) {
					t.multiBarcode = t.multiBarcodes[0].barcode
				}
				if (t.newCount != 0) {
					obj.push(t)
				}
			})
			await WhDocument.aktCreate(this.$route.params.id, obj).then(response => {
				this.$router.go(-2)
				this.$vs.notify({
					title: 'Successfully saved',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
			}).catch(e => {
				this.$vs.notify({
					text: 'Error: ' + JSON.parse(e.request.response).message,
					color: 'danger',
					time: 10000,
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		processFile(event) {
			this.file = event.target.files ? event.target.files[0] : null;
			if (this.file) {
				this.loaders = true
				const reader = new FileReader();

				reader.onload = (e) => {
					this.loaders = true
					/* Parse data */
					const bstr = e.target.result;
					const wb = XLSX.read(bstr, {type: 'binary'});
					/* Get first worksheet */
					const wsname = wb.SheetNames[0];
					const ws = wb.Sheets[wsname];
					/* Convert array of arrays */
					const data = XLSX.utils.sheet_to_json(ws, {header: 1});
					// this.excelItem=data
					let isSuccess = 0;

					data.splice(0, 1);
					data.forEach(e => {
						this.loaders = true
						let exists = false;
						let termOfItem = e[1],
							spiceCode = e[0],
							barcode = e[2],
							newCount = e[3]

						this.item.whItems.forEach(i => {
							i.multiBarcodes.forEach(t => {
								if (barcode == t.barcode && termOfItem == i.termOfItem && spiceCode == i.barcode) {
									this.loaders = true
									if (parseFloat(newCount) > parseFloat(i.count)) {
										this.$set(i, 'newCount', parseFloat(newCount) - parseFloat(i.count))
										this.$set(i, 'newCountExcel', newCount)
										this.$set(i, 'equal', "+")
										this.$set(i, 'checked', true);

									} else if (parseFloat(newCount) < parseFloat(i.count)) {
										this.$set(i, 'newCount', parseFloat(i.count) - parseFloat(newCount))
										this.$set(i, 'newCountExcel', newCount)
										this.$set(i, 'equal', "-")
										this.$set(i, 'checked', true);
									} else if (parseFloat(newCount) == parseFloat(i.count)) {
										i.equal = ""
										this.$set(i, 'newCount', 0)
										this.$set(i, 'newCountExcel', newCount)
										this.$set(i, 'checked', true);
										if (i.newCount == 0) {
											isSuccess++;
										}
									}
									exists = true;
									return false;
								}
							})
						});
						this.loaders = false
						// if (!exists) {
						// 	let data =
						// 		{
						// 			multiBarcodes: [{barcode: barcode}],
						// 			termOfItem: termOfItem,
						// 			count: 0,
						// 			newCountExcel: newCount,
						// 			itemName: '',
						// 			equal: '',
						// 			newCount: 0
						//
						// 		}
						//
						// 	this.item.whItems.push(
						// 		data
						// 	);
						// }
					})
					if (this.item.whItems.length === isSuccess) {
						this.showSaccess = true
					} else {
						this.showSaccessAkt = true
					}
				}
				reader.readAsBinaryString(this.file);
			}
			this.showReset = true
		},
		exportToExcel() {
			this.dataForExcel = []
			this.loaders = true
			setTimeout(async () => {
				await WhDocument.get(this.item.id).then(response => {
					for (let j = 0; j < response.data.whItems.length; j++) {
						let data = {
							'Спец-код': response.data.whItems[j].barcode,
							'Количество': response.data.whItems[j].count,
							'Продажная цена': response.data.whItems[j].currentPrice,
							'Новая приходная цена': response.data.whItems[j].newIncomePrice,
							'Новая продажная цена': response.data.whItems[j].priceUzs
						}
						this.dataForExcel.push(data)
					}
					this.loaders = false
				}).catch(error => {
					this.loaders = false
				})
			}, 1000);
		}
		,
		get() {
			return WhDocument.get(this.$route.params.id).then(response => {
				this.item = response.data;
				this.sumPrice(this.item);
				this.sumIncome(this.item);
			}).catch(error => {
				// this.loader = false
			})

		}
		,

	},
	created() {
		this.get()

	}
	,
	watch: {}
}
</script>

<style scoped lang="scss">

@page  {
	margin: 1cm;
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}

.nakladnoyWholesale {
	margin: 0 20px;
}

@media print {
	.hidden-print {
		display: none;
	}
	.mt {
		padding-top: 200px !important;
	}
	.card {
		box-shadow: none;
	}
	#nakladnoyTableWrapper {
		display: block;
	}
}

.saldoInfoTexts {
	width: 88%;

	span {
		display: inline-block;
		width: 18%;
	}

	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;
		width: 80%;
	}

	/*input.bottomBorderedInput:focus {
	border-color: green
	}*/
}


.signsOfAccountants {
	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;
		width: 40%;
	}

	p {
		width: 40%;

		&.sign {
			text-align: center;
			font-size: 12px;
		}
	}
}

input.bottomBorderedInput {
	outline: 0;
	border-width: 0 0 .5px;
	border-color: black;

	&.width70 {
		width: 70px;
	}

	&.width80 {
		width: 80px;
	}

	&.forDate {
		width: 40px;
		text-align: right;

		&.borderRed {
			border-color: red;
			color: red;
		}
	}
}

h6.bottomBorderedInput {
	outline: 0;
	border-width: 0 0 .5px;
	border-color: black;

	&.width70 {
		width: 70px;
	}

	&.width80 {
		width: 80px;
	}

	&.forDate {
		width: 40px;
		text-align: right;

		&.borderRed {
			border-color: red;
			color: red;
		}
	}
}

#nakladnoyTableWrapper {
	.table {
		td, th {
			border: 1px solid black;
			vertical-align: middle;

			&.borderRightNone {
				border-right: none;
			}

			&.borderLeftNone {
				border-left: none;
			}

			&.borderTopNone {
				border-top: none;
			}

			&.borderBottomNone {
				border-bottom: none;
			}

			color: black;
		}

		#moldavianItemsHeader {
			th {
				font-size: 9px;
				border-bottom: none;
			}

			.width27 {
				width: 27%;
			}
		}

		#russianItemsHeader {
			th {
				font-size: 9px;
				border-top: none;
			}

			.greyText {
				color: #999999;
			}
		}

		.docItemRow {
			td {
				text-align: right;

				&.docItemUnit {
					text-align: center;
				}

				&:first-child {
					text-align: unset;
				}

				padding: 0 .5rem;
			}
		}

		th {
			font-size: 11px;
		}


		.moldavianText {
			font-weight: bold;
		}

		.fontWeightNormal {
			font-weight: normal;
		}

		tfoot {
			th, td {
				font-weight: bold;
				font-size: 11px;
				text-align: right;

				&.textAlignCenter {
					text-align: center;
				}

				&:first-child {
					text-align: unset;
				}

				padding: 0 .5rem;
			}
		}
	}
}

.customSize {
	font-size: 10px;
}

.customSizeItem {
	font-size: 12px;
}

.nobr {
	white-space: nowrap;
}

.strong {
	font-weight: bold;
}

#docUpperPart {
	p {
		margin-bottom: 0;
	}

	margin-bottom: .5rem;

	#docImgLogoName {
		margin-left: 32%;
		width: 300px;
		height: auto;
	}

	#docImgLogo {
		width: 180px;
		height: 70px;
	}

	#docUpperPartLeft {
		#docUpperPartTxt {
			margin-top: .5rem;
			display: inline-block;
			width: 30%;

			p {
				display: inline-block;
			}
		}

		#barcodeImgForSeria {
			cursor: pointer;
			display: inline-block;
			width: 30%;

			svg {
				vertical-align: bottom;
				width: 46mm !important;
				height: auto !important;

				g {
					text {
						font-size: 14px !important;
						transform: translateY(46px) !important;
					}
				}
			}
		}

		display: inline-block;
		width: 74%;

		#seriaInputForBarcode {
			display: inline-block;

			input {
				margin-left: .5rem;
				width: 10rem;
				height: 1.2rem;
			}
		}
	}

	#docUpperPartRight {
		display: inline-block;
		width: 26%;
		vertical-align: top;
		text-align: right;

		#rightPartTxt {
			font-size: 10px;
		}
	}
}
</style>
